/* bacter-hogar.js
   Calculadora de dosis para Hogar y Vivienda pequeña (Bacter spp.)
   - Base: 15 g/mes para 5 personas
   - Puntos internos: WC, regadera, lavabo, tarja, lavadora, patio, coladeras
   - 10% extra por cada persona adicional sobre 5
   - Dosis mínima: 15 g/mes (aunque haya pocos puntos)
   - Reparto por uso: aseo personal, aseo doméstico, lavandería
   - Regla de dilución base: 15 g -> 1 L de agua tibia
   - Volumen de dilución mostrado en litros, redondeado a múltiplos de 0.5 L
*/

(function () {
  'use strict';

  var BASE_GRAMOS   = 15;  // 15 g/mes por vivienda pequeña
  var BASE_PERSONAS = 5;   // Base pensada para 5 personas
  var BASE_PUNTOS   = 10;  // 1 WC, 1 regadera, 1 lavabo, 1 tarja, 1 lavadora, 1 patio, 3 coladeras, 1 registro

  var CARGA_MULT = { 'baja': 0.8, 'media': 1.0, 'alta': 1.5 };
  var MODO_MULT  = { 'mantenimiento': 1.0, 'choque': 2.0 };

  function qsa(selector, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(selector));
  }
  function el(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }

  function calcularPuntosInternos(wc, regaderas, lavabos, tarjas, lavadoras, patios, coladeras) {
    var puntos = 0;
    puntos += wc;
    puntos += regaderas;
    puntos += lavabos;
    puntos += tarjas;
    puntos += lavadoras;
    puntos += patios;
    puntos += coladeras;
    puntos += 1; // registro/cámara principal
    return puntos;
  }

  function renderWidget(container, cfg) {
    container.innerHTML = '';

    var title = cfg.title || '🔢 Calcula aquí la dosis recomendada — Bacter spp.';
var h = el('div');
h.className = 'bacter-title';   // ← ESTA LÍNEA ES IMPORTANTE
h.style.fontWeight = '800';
h.style.marginBottom = '8px';
h.style.fontSize = '24px';      // este valor luego lo controla el CSS
h.style.textAlign = 'center';
h.innerText = title;
container.appendChild(h);


    var form = el('div');
    form.style.display = 'flex';
    form.style.flexWrap = 'wrap';
    form.style.gap = '8px';
    form.style.marginBottom = '10px';

    function labeledNumber(id, label, value, extraConfig) {
      var wrap = el('label');
      wrap.style.flex = '1 1 200px';
      wrap.style.fontSize = '13px';
      wrap.style.display = 'block';

      var lbl = el('div');
      lbl.style.fontWeight = '600';
      lbl.style.marginBottom = '6px';
      lbl.innerText = label;

      var input = el('input');
      input.type = 'number';
      input.value = (value !== undefined ? value : 0);
      input.min = 0;
      input.style.width = '100%';
      input.style.padding = '8px';
      input.style.border = '1px solid #dcdcdc';
      input.style.borderRadius = '6px';
      input.setAttribute('data-role', id);

      if (extraConfig && extraConfig.readonly) {
        input.readOnly = true;
        input.style.backgroundColor = '#f3f3f3';
      }

      wrap.appendChild(lbl);
      wrap.appendChild(input);
      return wrap;
    }

    // Vivienda fija = 1
    form.appendChild(labeledNumber('viviendas', 'Nº Viviendas (fijo)', 1, { readonly: true }));

    form.appendChild(labeledNumber('habitantes', 'Nº de Personas', cfg.defaults.habitantes));

    form.appendChild(labeledNumber('wc', 'Nº WC / Mingitorios', cfg.defaults.wc));
    form.appendChild(labeledNumber('regaderas', 'Nº Regaderas', cfg.defaults.regaderas));
    form.appendChild(labeledNumber('lavabos', 'Nº Lavabos', cfg.defaults.lavabos));
    form.appendChild(labeledNumber('tarjas', 'Nº Tarjas / Fregaderos', cfg.defaults.tarjas));
    form.appendChild(labeledNumber('lavadoras', 'Nº Lavadoras', cfg.defaults.lavadoras));
    form.appendChild(labeledNumber('patios', 'Nº Patios / Lavaderos', cfg.defaults.patios));
    form.appendChild(labeledNumber('coladeras', 'Nº Coladeras', cfg.defaults.coladeras));

    // Reparto por uso
    var repartDiv = el('div');
    repartDiv.style.flex = '1 1 280px';
    var repartLbl = el('div');
    repartLbl.style.fontWeight = '600';
    repartLbl.style.marginBottom = '6px';
    repartLbl.innerText = 'Reparto de uso (¿dónde se usa más el agua?)';
    var selectRep = el('select');
    selectRep.style.padding = '8px';
    selectRep.style.border = '1px solid #dcdcdc';
    selectRep.style.borderRadius = '6px';
    selectRep.setAttribute('data-role', 'reparto');

    var optEq = el('option');
    optEq.value = 'equilibrado';
    optEq.innerText = 'Equilibrado: parecido en baño, cocina y lavado';

    var optBan = el('option');
    optBan.value = 'banos';
    optBan.innerText = 'Más en baño (WC y regaderas)';

    var optDom = el('option');
    optDom.value = 'cocina_domestico';
    optDom.innerText = 'Más en cocina / aseo doméstico';

    var optLav = el('option');
    optLav.value = 'lavanderia';
    optLav.innerText = 'Más en lavandería';

    selectRep.appendChild(optEq);
    selectRep.appendChild(optBan);
    selectRep.appendChild(optDom);
    selectRep.appendChild(optLav);

    repartDiv.appendChild(repartLbl);
    repartDiv.appendChild(selectRep);
    form.appendChild(repartDiv);

    // Carga orgánica
    var cargaDiv = el('div');
    cargaDiv.style.flex = '1 1 200px';
    var lblCarga = el('div');
    lblCarga.style.fontWeight = '600';
    lblCarga.style.marginBottom = '6px';
    lblCarga.innerText = 'Carga orgánica';
    var selCarga = el('select');
    selCarga.setAttribute('data-role', 'carga');
    selCarga.style.padding = '8px';
    selCarga.style.border = '1px solid #dcdcdc';
    ['baja', 'media', 'alta'].forEach(function (v) {
      var o = el('option');
      o.value = v;
      o.innerText =
        v === 'baja'
          ? 'Baja (poca carga)'
          : v === 'media'
          ? 'Media (uso normal)'
          : 'Alta (muchas grasas/residuos)';
      if (v === cfg.defaults.carga) o.selected = true;
      selCarga.appendChild(o);
    });
    cargaDiv.appendChild(lblCarga);
    cargaDiv.appendChild(selCarga);
    form.appendChild(cargaDiv);

    // Modo
    var modoDiv = el('div');
    modoDiv.style.flex = '1 1 200px';
    var lblModo = el('div');
    lblModo.style.fontWeight = '600';
    lblModo.style.marginBottom = '6px';
    lblModo.innerText = 'Modo de aplicación';
    var selModo = el('select');
    selModo.setAttribute('data-role', 'modo');
    selModo.style.padding = '8px';
    selModo.style.border = '1px solid #dcdcdc';
    ['mantenimiento', 'choque'].forEach(function (v) {
      var o = el('option');
      o.value = v;
      o.innerText =
        v === 'mantenimiento'
          ? 'Mantenimiento (uso regular)'
          : 'Choque (tratamiento intensivo)';
      if (v === cfg.defaults.modo) o.selected = true;
      selModo.appendChild(o);
    });
    modoDiv.appendChild(lblModo);
    modoDiv.appendChild(selModo);
    form.appendChild(modoDiv);

    // Químicos
    var qDiv = el('div');
    qDiv.style.flex = '1 1 260px';
    qDiv.style.display = 'flex';
    qDiv.style.alignItems = 'flex-end';
    var chk = el('input');
    chk.type = 'checkbox';
    chk.setAttribute('data-role', 'quimicos');
    chk.checked = cfg.defaults.quimicos;
    var chkLbl = el('label');
    chkLbl.style.marginLeft = '8px';
    chkLbl.style.fontSize = '13px';
    chkLbl.innerText = '¿Usan cloro, sosa o desengrasantes muy fuertes con frecuencia?';
    qDiv.appendChild(chk);
    qDiv.appendChild(chkLbl);
    form.appendChild(qDiv);

    container.appendChild(form);

    // Resultado
    var res = el('div');
    res.setAttribute('data-role', 'resultado');
    res.style.marginTop = '12px';
    res.style.padding = '12px';
    res.style.background = '#f8f9fa';
    res.style.borderRadius = '6px';
    res.style.display = 'none';
    container.appendChild(res);

    // Recalcular en automático
    qsa('input[type="number"]', container).forEach(function (inp) {
      inp.addEventListener('input', function () { doCalc(container, cfg); });
    });
    qsa('select', container).forEach(function (sel) {
      sel.addEventListener('change', function () { doCalc(container, cfg); });
    });
    var qNode = container.querySelector('[data-role="quimicos"]');
    if (qNode) {
      qNode.addEventListener('change', function () { doCalc(container, cfg); });
    }

    doCalc(container, cfg);
  }

    function doCalc(container, cfg) {
    function getVal(sel, asInt) {
      var node = container.querySelector('[data-role="' + sel + '"]');
      if (!node) return 0;
      if (node.type === 'checkbox') return node.checked;
      var v = node.value;
      if (asInt) return parseInt(v || 0, 10) || 0;
      return v || 0;
    }

    // Vivienda fija = 1
    var viviendas = 1;

    var habitantes = getVal('habitantes', true);
    if (habitantes <= 0) habitantes = cfg.defaults.habitantes || BASE_PERSONAS;

    var wc         = getVal('wc', true);
    var regaderas  = getVal('regaderas', true);
    var lavabos    = getVal('lavabos', true);
    var tarjas     = getVal('tarjas', true);
    var lavadoras  = getVal('lavadoras', true);
    var patios     = getVal('patios', true);
    var coladeras  = getVal('coladeras', true);

    var reparto = getVal('reparto') || cfg.defaults.reparto || 'equilibrado';
    if (reparto === 'recommended') reparto = 'equilibrado';

    var carga    = getVal('carga') || cfg.defaults.carga || 'media';
    var modo     = getVal('modo') || cfg.defaults.modo || 'mantenimiento';
    var quimicos = container.querySelector('[data-role="quimicos"]')
      ? container.querySelector('[data-role="quimicos"]').checked
      : cfg.defaults.quimicos;

    var puntosActuales = calcularPuntosInternos(
      wc, regaderas, lavabos, tarjas, lavadoras, patios, coladeras
    );

    // Si el usuario borra todo, reponemos la base mínima de puntos
    if (puntosActuales <= 1) {
      wc        = wc        || 1;
      regaderas = regaderas || 1;
      lavabos   = lavabos   || 1;
      tarjas    = tarjas    || 1;
      lavadoras = lavadoras || 1;
      patios    = patios    || 1;
      coladeras = coladeras || 3;
      puntosActuales = calcularPuntosInternos(
        wc, regaderas, lavabos, tarjas, lavadoras, patios, coladeras
      );
    }

    // Base según puntos
    var gramosPorPunto    = BASE_GRAMOS / BASE_PUNTOS; // 1.5 g por punto
    var baseSegunPuntos   = gramosPorPunto * puntosActuales;

    // Ajuste por personas (10% por persona adicional sobre 2)
    var factorPersonas    = 1 + 0.10 * (habitantes - BASE_PERSONAS);
    if (factorPersonas < 0.5) factorPersonas = 0.5;

    var baseConPersonas   = baseSegunPuntos * factorPersonas;

    // multiplicadores por carga y modo
    var mult_carga        = CARGA_MULT[carga] || 1.0;
    var mult_modo         = MODO_MULT[modo] || 1.0;
    var ajustado          = baseConPersonas * mult_carga * mult_modo;
    if (quimicos) ajustado = ajustado * 1.5;

    ajustado = Math.round(ajustado);

    // **Nunca bajar de la dosis mínima de 15 g**
    if (ajustado < BASE_GRAMOS) ajustado = BASE_GRAMOS;

    // === Dilución base: 15 g -> 1 L ===
    var litrosCrudos = ajustado > 0 ? (ajustado / BASE_GRAMOS) : 0;

    // Redondear a múltiplos de 0.5 L, con empates hacia abajo
    var litrosRedondeados = 0;
    if (litrosCrudos > 0) {
      var steps = litrosCrudos / 0.5;
      var low   = Math.floor(steps) * 0.5;
      var high  = Math.ceil(steps) * 0.5;
      var distLow  = Math.abs(litrosCrudos - low);
      var distHigh = Math.abs(litrosCrudos - high);
      litrosRedondeados = (distHigh < distLow) ? high : low;
      if (litrosRedondeados <= 0) litrosRedondeados = 0.5; // mínimo 0.5 L
    }

    // vol total en ml solo para cálculos internos
    var totalAguaMl = Math.round(litrosRedondeados * 1000);

    // Grupos de uso
    var puntosPersonal   = wc + regaderas + lavabos;
    var puntosDomestico  = tarjas + patios + coladeras;
    var puntosLavanderia = lavadoras;

    // Repartos por escenario seleccionado
    var fPersonal = 0.4, fDomestico = 0.4, fLavanderia = 0.2; // equilibrado
    if (reparto === 'banos') {
      fPersonal = 0.6; fDomestico = 0.3; fLavanderia = 0.1;
    } else if (reparto === 'cocina_domestico') {
      fPersonal = 0.3; fDomestico = 0.5; fLavanderia = 0.2;
    } else if (reparto === 'lavanderia') {
      fPersonal = 0.3; fDomestico = 0.3; fLavanderia = 0.4;
    }

    var gramosPersonal   = Math.round(ajustado * fPersonal);
    var gramosDomestico  = Math.round(ajustado * fDomestico);
    var gramosLavanderia = ajustado - gramosPersonal - gramosDomestico;

    var puntosTot = puntosActuales;

    // mL por grupo, en función del volumen total redondeado
    var mlPersonal   = (ajustado > 0 && totalAguaMl > 0) ? Math.round(totalAguaMl * gramosPersonal   / ajustado) : 0;
    var mlDomestico  = (ajustado > 0 && totalAguaMl > 0) ? Math.round(totalAguaMl * gramosDomestico  / ajustado) : 0;
    var mlLavanderia = (ajustado > 0 && totalAguaMl > 0) ? Math.round(totalAguaMl * gramosLavanderia / ajustado) : 0;

    // convertir a litros con 1 decimal
    function mlToLitStr(ml){
      if (!ml || ml <= 0) return '';
      var litros = ml / 1000;
      var txt = litros.toFixed(1);
      txt = txt.replace(/\.0$/, ''); // quitar .0
      return txt + ' L';
    }

    // ==== Resultado (todo en gramos y L) ====
    var html = '<div style="font-size:18px;">' +
               'Dosis recomendada por mes: ' +
               '<span style="font-size:24px;font-weight:900;color:#0b3d91;">' + ajustado + ' g</span>' +
               '</div>';

    if (litrosRedondeados > 0) {
  var litTotalTxt = litrosRedondeados.toFixed(1).replace(/\.0$/, '');
  var unidad = (litTotalTxt === '1') ? 'litro' : 'litros';

  html += '<div style="margin-top:8px;font-size:15px;color:#0b3d91;">' +
          'Esta dosis mensual debes diluirla en <strong>' + litTotalTxt + ' ' + unidad +
          '</strong> de agua tibia (no caliente) y usar esa solución para repartirla en los distintos puntos de la casa como se muestra a continuación.' +
          '</div>';
}


    html += '<div style="margin-top:10px;font-size:16px;"><strong>Cómo repartirla en tu casa:</strong></div>';

    html += '<div style="margin-top:6px;font-size:15px;">' +
            '<strong>Aseo personal</strong> (WC, regaderas, lavabos): ' +
            '<strong>' + gramosPersonal + ' g/mes</strong>' +
            (mlPersonal > 0 ? ' — ≈ <strong>' + mlToLitStr(mlPersonal) + '</strong> de la solución para esta zona.' : '') +
            '</div>';

    html += '<div style="margin-top:4px;font-size:15px;">' +
            '<strong>Aseo doméstico</strong> (tarja/fregadero, patios, coladeras): ' +
            '<strong>' + gramosDomestico + ' g/mes</strong>' +
            (mlDomestico > 0 ? ' — ≈ <strong>' + mlToLitStr(mlDomestico) + '</strong> de la solución para esta zona.' : '') +
            '</div>';

    html += '<div style="margin-top:4px;font-size:15px;">' +
            '<strong>Lavandería</strong> (lavadora / área de lavado): ' +
            '<strong>' + gramosLavanderia + ' g/mes</strong>' +
            (mlLavanderia > 0 ? ' — ≈ <strong>' + mlToLitStr(mlLavanderia) + '</strong> de la solución para lavandería.' : '') +
            '</div>';

    html += '<div style="margin-top:10px;font-size:15px;color:#333;">' +
            '<strong>Puntos totales considerados:</strong> ' + puntosTot +
            ' (incluye 1 punto extra por el registro/cámara principal).' +
            '</div>';

    html += '<div style="margin-top:12px;color:#444;font-size:15px;">' +
            'Sugerencia: aplica preferentemente por la noche o en horas de poco uso. ' +
            'Si hay olores fuertes o problemas recurrentes en un punto (por ejemplo un WC o coladera), ' +
            'puedes concentrar ahí parte de la dosis de su categoría durante algunos días y luego volver al reparto normal.' +
            '</div>';

    html += '<div style="margin-top:8px;font-size:14px;color:#666;">' +
            '<em>Nota técnica:</em> pH recomendado 5–9; temperatura ideal ~28 °C. Ajusta en campo según resultados y condiciones reales.' +
            '</div>';

    var resDiv = container.querySelector('[data-role="resultado"]');
    resDiv.innerHTML = html;
    resDiv.style.display = 'block';
  }


  function init() {
    var widgets = qsa('.bacter-widget[data-scenario="hogar_vivienda"]');

    if (!widgets.length) return;
    widgets.forEach(function (elWidget) {
      try {
        var cfg = {
          scenario: elWidget.getAttribute('data-scenario') || 'hogar_vivienda',
          title: elWidget.getAttribute('data-title') || null,
          defaults: {
            habitantes: parseInt(elWidget.getAttribute('data-default-habitantes') || 2, 10),
            wc:         parseInt(elWidget.getAttribute('data-default-wc')         || 1, 10),
            regaderas:  parseInt(elWidget.getAttribute('data-default-regaderas')  || 1, 10),
            lavabos:    parseInt(elWidget.getAttribute('data-default-lavabos')    || 1, 10),
            tarjas:     parseInt(elWidget.getAttribute('data-default-tarjas')     || 1, 10),
            lavadoras:  parseInt(elWidget.getAttribute('data-default-lavadoras')  || 1, 10),
            patios:     parseInt(elWidget.getAttribute('data-default-patios')     || 1, 10),
            coladeras:  parseInt(elWidget.getAttribute('data-default-coladeras')  || 3, 10),
            carga:      elWidget.getAttribute('data-default-carga')      || 'media',
            modo:       elWidget.getAttribute('data-default-modo')       || 'mantenimiento',
            reparto:    elWidget.getAttribute('data-default-reparto')    || 'equilibrado',
            quimicos:  (elWidget.getAttribute('data-default-quimicos')   === 'true')
          }
        };
        renderWidget(elWidget, cfg);
      } catch (err) {
        console.error('bacter-hogar init error', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
